import { gql } from '@apollo/client';
import { AccountCreditCardInfoShared } from '../fragments';

export default gql`
  mutation actionAccountCreditCardDefault($input: AccountCreditCardDefaultActionInput!) {
    actionAccountCreditCardDefault(input: $input) {
      clientMutationId
      accountCreditCard {
        ...AccountCreditCardInfoShared
      }
    }
  }
  ${AccountCreditCardInfoShared}
`;
